
<template>
  <div>
    <HeaderApp
      @logout="authStore.clearUserData"
    />

    <GuestContent
      v-show="!modalStore.isOpenCabinet"
    />

    <DashboardApp v-show="modalStore.isOpenCabinet" />

    <RegisterModal
      v-if="modalStore.isRegisterModalOpen"
    />
    <ResetPasswordModal
      v-if="modalStore.isResetPasswordModalOpen"
    />
    <LoginModal
      v-if="modalStore.isLoginModalOpen"
      @logged-in="handleLoggedIn"
    />
    <AuthModal
      v-if="modalStore.isAuthModalOpen"
    />
    <PhoneModal v-if="modalStore.isPhoneModalOpen" />
    <RulesModal v-if="modalStore.isRulesModalOpen" />
    <MessageModal v-if="modalStore.isMessageModalOpen" />
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { useModalStore } from "@/stores/modals";
import HeaderApp from "./components/HeaderApp/HeaderApp.vue";
import GuestContent from "./components/guest-content/GuestContent.vue";
import RegisterModal from "./components/modals/RegisterModal.vue";
import ResetPasswordModal from "./components/modals/ResetPasswordModal.vue";
import LoginModal from "./components/modals/LoginModal.vue";
import DashboardApp from "./components/registered-content/DashboardApp.vue";
import AuthModal from "./components/modals/AuthModal.vue";
import PhoneModal from "./components/modals/PhoneModal.vue";
import RulesModal from "./components/modals/RulesModal.vue";
import MessageModal from "./components/modals/MessageModal.vue";

export default {
  components: {
    HeaderApp,
    GuestContent,
    RegisterModal,
    ResetPasswordModal,
    LoginModal,
    DashboardApp,
    AuthModal,
    PhoneModal,
    RulesModal,
    MessageModal,
  },

  setup() {
    const authStore = useAuthStore();
    const modalStore = useModalStore();

    return { authStore, modalStore };
  },

  data() {
    return {
    };
  },

  methods: {
    async handleVerified(token) {
      this.authStore.setToken(token);
      await this.authStore.fetchAmocrmData();
      this.modalStore.closeResetPasswordModal();
      this.modalStore.openCabinet();
    },

    async handleLoggedIn(token) {
      this.authStore.setToken(token);
      await this.authStore.fetchAmocrmData();
      this.modalStore.closeLoginModal();
      this.modalStore.closeAuthModal();
      this.modalStore.openCabinet();
    },

    switchToSite() {
      this.modalStore.closeCabinet();
    },
  },

  mounted() {
    this.modalStore.closeCabinet();
    this.authStore.checkTokenAndLoad();
  },
};
</script>